import { belongsTo, Model } from 'miragejs';

export default Model.extend({
  desk: belongsTo('graphql/desk'),
  employee: belongsTo('graphql/employee', { inverse: 'assignments' }),
  scheduledBy: belongsTo('graphql/employee', { inverse: null }),
});
